import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { ReportTemplatesRoutes } from '@repo/shared/api-routes/report-templates'
import { ReportTemplateDTO } from '@repo/shared/dtos/report'
import { AxiosInstance } from 'axios'

import { IReportTemplatesApi } from '@/spi/api/report-templates'
import { ReportTemplate } from '@/store/report-templates/types'

export const buildReportTemplatesApi = (axios: AxiosInstance): IReportTemplatesApi => ({
  getAll: async ({ organizationId }) => {
    const response = await tryCatch(async () =>
      axios.get<typeof ReportTemplatesRoutes.getAll.response>(
        ReportTemplatesRoutes.getAll.getPath({ organizationId }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return response.data.map(toReportTemplate)
  },

  createOne: async ({ organizationId, fields }) => {
    const response = await tryCatch(async () =>
      axios.post<typeof ReportTemplatesRoutes.createOne.response>(
        ReportTemplatesRoutes.createOne.getPath({ organizationId }),
        { payload: fields } satisfies typeof ReportTemplatesRoutes.createOne.request,
      ),
    )
    if (hasError(response)) return handleError(response)
    return toReportTemplate(response.data)
  },

  deleteOne: async ({ organizationId, reportTemplateId }) => {
    const response = await tryCatch(async () =>
      axios.delete<typeof ReportTemplatesRoutes.deleteOne.response>(
        ReportTemplatesRoutes.deleteOne.getPath({
          organizationId,
          reportTemplateId,
        }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return response.data
  },

  updateOne: async ({ organizationId, reportTemplateId, fields }) => {
    const response = await tryCatch(async () =>
      axios.patch<typeof ReportTemplatesRoutes.updateOne.response>(
        ReportTemplatesRoutes.updateOne.getPath({
          organizationId,
          reportTemplateId,
        }),
        { payload: fields } satisfies typeof ReportTemplatesRoutes.updateOne.request,
      ),
    )
    if (hasError(response)) return handleError(response)
    return toReportTemplate(response.data)
  },
})

function toReportTemplate(dto: ReportTemplateDTO): ReportTemplate {
  return {
    id: dto.id,
    name: dto.name,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    instructions: dto.instructions,
    description: dto.description,
    type: dto.type,
  }
}
